var _symbol, _symbol2, _rect, _use, _use2, _use3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "card",
    face: "AS",
    width: "10em",
    preserveAspectRatio: "none",
    viewBox: "-120 -168 240 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "VSA",
    viewBox: "-500 -500 1000 1000",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-270 460L-110 460M-200 450L0 -460L200 450M110 460L270 460M-120 130L120 130",
    stroke: "black",
    strokeWidth: 80,
    strokeLinecap: "square",
    strokeMiterlimit: 1.5,
    fill: "none"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "SSA",
    viewBox: "-600 -600 1200 1200",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -500C100 -250 355 -100 355 185A150 150 0 0 1 55 185A10 10 0 0 0 35 185C35 385 85 400 130 500L-130 500C-85 400 -35 385 -35 185A10 10 0 0 0 -55 185A150 150 0 0 1 -355 185C-355 -100 -100 -250 0 -500Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 335,
    x: -119.5,
    y: -167.5,
    rx: 12,
    ry: 12,
    fill: "white",
    stroke: "black"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SSA",
    height: 164.8,
    x: -82.4,
    y: -82.4
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VSA",
    height: 32,
    x: -114.4,
    y: -156
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SSA",
    height: 26.769,
    x: -111.784,
    y: -119
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#VSA",
    height: 32,
    x: -114.4,
    y: -156
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SSA",
    height: 26.769,
    x: -111.784,
    y: -119
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/as.74614713.svg";
export { ForwardRef as ReactComponent };